import {Component, NgZone, Input, Output, EventEmitter} from "@angular/core";
import "rxjs/add/operator/map";
import "rxjs/add/operator/subscribeOn";
import {ComponentBase} from "../base/ComponentBase";
import {PipelineService} from "../services/pipeline/pipeline.service";
import {VocabularyEntry} from "../services/pipeline/vocabulary.pipeline.service";
import {CssWord} from "../content/content-view.objects";
import {RaVersion} from "../services/configuration/ra.version";

@Component({
    selector: "vocabulary-editor-detail",
    templateUrl:  "./vocabulary.editor.detail.component.html",
    styleUrls: ["./pipeline.component.scss"]
})
// "Read-only" view of one vocabulary term
export class VocabularyEditorDetailComponent extends ComponentBase {

    @Output()
    public replaceRequest: EventEmitter<string> = new EventEmitter<string>();

    @Output()
    public deleteRequest: EventEmitter<string> = new EventEmitter<string>();

    @Input()
    public idx: string;

    @Input()
    public isEditable:boolean;

    @Input()
    public vocabularyInfo:VocabularyEntry = null;

    @Input()
    public saveInProgress:boolean = false;

    @Input()
    public selectedWord: CssWord = null;

    constructor(private pipelineService:PipelineService) {
        super("VocabularyEditorDetailComponent");
    }

    public changeDisabled():boolean {
        return this.saveInProgress;
    }

    public isNewEntry():boolean {
        return this.idx === "newVocabularyEntry";
    }

    public replaceVocabularyEntry():void {
        this.replaceRequest.emit(this.idx);
    }

    public deleteVocabularyEntry():void {
        this.deleteRequest.emit(this.idx);
    }
}
